class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-page');
    this.submitButton = this.querySelector('[type="submit"]');
    if (this.nodeName == 'ADD-ON-FORM') {
      this.cart = document.querySelector('addon-cart');
    }
    
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;


    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (this.dataset.cartType == 'page') {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        console.log(this.dataset);

        if (this.dataset.showCards) {
          console.log('toon kaarten');

              if ($('.c_p-addon input').is(':checked')) {
      var c_id = $(".c_p-addon input:checked").val();
      $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
              quantity: 1,
              id: c_id
            },
      success:function(cart){     
 document.dispatchEvent(
            new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
          );
      }, 
      error:function(msg){
        console.log(JSON.parse(msg.responseText).description);
      },complete:function(cart){
      }
    });
      }
          
          this.addonDialog = this.addonDialog || document.querySelector('addon-dialog');
          this.addonDialog.show(this);

          return false;
        } else {
          if (this.cart) {
            this.cart.renderContents(response);
              if (this.nodeName == 'ADD-ON-FORM') {
                this.addToFooter(response);
              }
          } else {
            window.location = window.routes.cart_url;

          }
        }

      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define('product-form', ProductForm); 






class AddOnForm extends ProductForm {
constructor() {
  super();
  this.addonDialog = document.querySelector('addon-dialog');
  if (this.addonDialog) {
    this.totalPriceElement = this.addonDialog.querySelector('.current-order-price span');
    this.mobileTotalPriceElement = this.addonDialog.querySelector('.product-form__submit span.price');
  }
}

addToFooter(response) {
  this.addPrice(response.final_price);
  console.log(response);
}

addPrice(cart_price) {
  // this.totalPriceElement.textContent = `$${cart_price}`;
  // this.mobileTotalPriceElement.textContent = `$${cart_price}`;
  // console.log(cart_price);



  
}
}

customElements.define('add-on-form', AddOnForm); 


class AddOnCart extends HTMLElement {
constructor() {
  super();
}

}

customElements.define('add-on-cart', AddOnCart); 

